module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div>\n	<div class="b-company-employees__company"></div>\n</div>';

}
return __p
}